import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';
import { Button, Heading, Text, Grid } from '@simplywallst/ui-core';
import { useMutation } from '@tanstack/react-query';
import { deleteRefreshTokenAll } from '@simplywallst/services';
import { withAuth } from '@/utilities/queries';
import { useSnackbar } from '@/features/snackbar';
import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import { ROUTE_USER_LOGOUT } from '@/constants/routes';
import { useTranslation } from '@/hooks/useTranslation';

/**
 *
 * This component is rendered conditionally based on the feature flag:
 * https://us.app.unleash-hosted.com/usbb1018/projects/tesseracts/features/universal-signout
 *
 */
export function UniversalLogout() {
  const { addSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const t = useTranslation();
  const { mutate, status } = useMutation({
    mutationKey: ['SIGN_OUT_EVERYWHERE'],
    mutationFn: async () => {
      const response = await withAuth(deleteRefreshTokenAll);
      return response;
    },
    async onSuccess() {
      addSnackbar({
        message: t('app.user.profile.universalLogout.successMessage'),
        type: 'positive',
        lifeTime: 5000,
      });
      dispatch(redirect({ type: ROUTE_USER_LOGOUT }));
    },
  });
  return (
    <Grid gap="16px">
      <Heading as="h2">{t('app.user.profile.universalLogout.title')}</Heading>
      <Text typography="small" color="whiteRGBA" opacity={0.7}>
        {t('app.user.profile.universalLogout.description')}
      </Text>
      <Text typography="small" color="whiteRGBA" opacity={0.7}>
        {t('app.user.profile.universalLogout.notice')}
      </Text>
      <Button
        styleType="gentleLarge"
        alignIcon="right"
        data-cy-id="signout-everywhere"
        onClick={() => mutate()}
        disabled={status === 'pending'}
        isLoading={status === 'pending'}
      >
        {t('app.user.profile.universalLogout.buttonText')}
        <WarningSolid />
      </Button>
    </Grid>
  );
}
